import { useQuery } from "react-query";
import { INTERVAL_PENDING_OPERATIONS_COUNT } from "src/utils/config";
import { getAllPendingOperationsCount } from "src/api/signer";

export function useAllPendingOperationsCount(enabled: boolean = true) {
  const refetchInterval = Number(INTERVAL_PENDING_OPERATIONS_COUNT) * 1000;
  const res = useQuery(
    "getAllPendingOperationsCount",
    getAllPendingOperationsCount,
    { refetchInterval, enabled },
  );
  return {
    all: String(res.data?.all || ""),
    api_withdraw: String(res.data?.api_withdraw || ""),
    portal_withdraw: String(res.data?.portal_withdraw || ""),
    sweep: String(res.data?.sweep || ""),
    swap: String(res.data?.swap || ""),
    contract_sweep: String(res.data?.contract_sweep || ""),
  };
}
